import AOS from 'aos';
import 'aos/dist/aos.css';

/**
 * Initializes AOS with shared defaults. Disables animations when the user
 * prefers reduced motion (accessibility).
 */
export function applyPageAnimations(options = {}) {
  const reduced =
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  AOS.init({
    duration: 700,
    easing: 'ease-in-out',
    once: false,
    ...options,
    ...(reduced ? { disable: true } : {}),
  });
}
